import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import DatePicker from '@/components/datepicker/Index.vue';
import ActionButton from '@/components/action_button/Index.vue';
import PageTitle from '@/components/v2/PageTitle.vue';
import BaseTextArea from '@/components/v2/BaseTextArea';
import PhoneInput from '@/components/v2/PhoneInput.vue';
import KycDocumentForm from '@/components/v2/KycDocumentForm.vue';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import FormValidationMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import { PsgcCityModel } from '@/helpers/entities/models/PsgcCityModel';
import { PsgcRegionModel } from '@/helpers/entities/models/PsgcRegionModel';
import PsgcRegions from '@/plugins/graphql/queries/v2/psgc-all-regions.gql';
import PsgcCities from '@/plugins/graphql/queries/v2/psgc-all-cities.gql';
import { required, email } from 'vuelidate/lib/validators';
import { requiredProperty, invalidType } from '@/helpers/mixins/LocalizationHelper';
import _ from 'lodash';
import { BusinessType, IndustryType, InvidualType, GenderType, DocumentType, } from '@/helpers/entities/interfaces/v2/forms/KycFormFields';
import SaveAccountHolder from '@/plugins/graphql/mutations/v3/save-account-holder-info.gql';
import AppOwnerDetails from '@/plugins/graphql/queries/v3/app-owner-details.gql';
import FetchAccountHolder from '@/plugins/graphql/queries/v3/fetch-account-holder.gql';
import AppDisbursementQuery from '@/plugins/graphql/queries/v2/app-disbursement.gql';
import FileAction from '@/plugins/graphql/mutations/v3/file-action.gql';
import { Mutation } from 'vuex-class';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
let XenditKycVerification = class XenditKycVerification extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, FormValidationMixin, FormMixin, AlertMixin) {
    constructor() {
        super(...arguments);
        this.isSaving = false;
        this.accountHolderUuid = '';
        this.accountHolder = {};
        this.selectedRegionCode = '0';
        this.regionSelection = [];
        this.citySelection = [];
        this.steps = 1;
        this.menuDOB = false;
        this.menuDOR = false;
        this.kycDocuments = [];
        this.appOwner = {};
        this.form = {
            businessDetails: {
                type: BusinessType.CORPORATION,
                legal_name: '',
                trading_name: '',
                description: '',
                industry_category: IndustryType.ACCOMMODATION,
                date_of_registration: '',
                country_of_operation: 'PH',
            },
            individualDetails: {
                given_names: '',
                surname: '',
                phone_number: '',
                email: '',
                nationality: 'PH',
                place_of_birth: 'PH',
                date_of_birth: '',
                gender: GenderType.MALE,
                tax_identification_number: '',
                type: InvidualType.PIC,
                role: '',
            },
            businessAddress: {
                city: '',
                country: 'PH',
                district: 'N/A',
                postal_code: '',
                street_line1: '',
                street_line2: 'N/A',
                sub_district: 'N/A',
                province_state: '',
            },
            phoneNumber: '',
            email: '',
            websiteUrl: '',
        };
        this.businessTypeOptions = Object.values(BusinessType).map((value) => ({
            text: _.startCase(value),
            value,
        }));
        this.insdustryCategoryOptions = Object.values(IndustryType).map((value) => ({
            text: _.startCase(value),
            value,
        }));
        this.InvidualTypeOptions = Object.values(InvidualType).map((value) => {
            if (value === InvidualType.PIC) {
                return { text: 'PERSON IN CHARGE', value };
            }
            return { text: _.startCase(value), value };
        });
        this.genderOptions = Object.values(GenderType).map((value) => ({
            text: _.startCase(value),
            value,
        }));
        this.birFileUrl = '';
    }
    nextStep() {
        this.steps += 1;
    }
    previousStep() {
        this.steps -= 1;
    }
    handleRegionChange(selectedRegionName) {
        const selectedRegion = this.regionSelection.find((region) => region.name === selectedRegionName);
        if (selectedRegion) {
            const { regionCode } = selectedRegion;
            this.selectedRegionCode = regionCode;
        }
        else {
            this.selectedRegionCode = '0';
        }
        this.fetchCities();
    }
    async fetchRegions() {
        try {
            const data = await this.$apollo.query({
                query: PsgcRegions,
            });
            if (data) {
                const psgcRegions = data.data.allPsgcRegions.edges;
                const psgcRegionNode = (sc) => {
                    return new PsgcRegionModel(sc.node);
                };
                this.regionSelection = psgcRegions.map(psgcRegionNode);
            }
        }
        catch (error) {
            this.errorNotification(error.message);
        }
    }
    async fetchCities() {
        try {
            const data = await this.$apollo.query({
                query: PsgcCities,
                variables: {
                    regionCode: this.selectedRegionCode,
                },
            });
            if ({ data }) {
                const psgcCities = data.data.filteredPsgcCities.edges;
                const psgcRegionNode = (sc) => {
                    return new PsgcCityModel(sc.node);
                };
                this.citySelection = psgcCities.map(psgcRegionNode);
            }
        }
        catch (error) {
            this.errorNotification(error.message);
        }
    }
    isValidMobile(mobileNumber) {
        // Remove all spaces from the input
        if (mobileNumber) {
            const cleanedNumber = mobileNumber.replace(/\s/g, '');
            // Test against the regex for the cleaned number
            const phoneNumberRegex = /^\+639\d{9}$/;
            return phoneNumberRegex.test(cleanedNumber);
        }
        return false;
    }
    get phoneNumberErrors() {
        const errors = [];
        if (!this.$v.form?.individualDetails?.phone_number.$dirty) {
            return errors;
        }
        if (!this.$v.form?.individualDetails?.phone_number.required) {
            const msg = requiredProperty('Phone Number');
            errors.push(msg);
        }
        if (!this.$v.form?.individualDetails?.phone_number.invalidMobile) {
            const msg = 'Phone Number is invalid';
            errors.push(msg);
        }
        return errors;
    }
    get businessPhoneNumberErrors() {
        const errors = [];
        if (!this.$v.form?.phoneNumber?.$dirty) {
            return errors;
        }
        if (!this.$v.form?.phoneNumber.required) {
            const msg = requiredProperty('Phone Number');
            errors.push(msg);
        }
        if (!this.$v.form?.phoneNumber.invalidMobile) {
            const msg = 'Phone Number is invalid';
            errors.push(msg);
        }
        return errors;
    }
    get websiteUrlErrors() {
        const errors = [];
        if (!this.$v.form?.websiteUrl?.$dirty) {
            return errors;
        }
        if (!this.$v.form?.websiteUrl.required) {
            const msg = requiredProperty('Website Url');
            errors.push(msg);
        }
        if (!this.$v.form?.websiteUrl.url) {
            const msg = 'Invalid website URL';
            errors.push(msg);
        }
        return errors;
    }
    get trailingWhitespace() {
        return (value) => {
            const hasTrailingWhitespace = value.trim() !== value;
            return hasTrailingWhitespace;
        };
    }
    getEmailErrors(emailList, emailType, emailTypeSpace) {
        const errors = [];
        let hasWhitespace = false;
        if (emailList && this.trailingWhitespace(emailList)) {
            hasWhitespace = true;
            errors.push('Invalid input. Please make sure that there are no whitespaces before or after the email addresses provided');
        }
        if (!hasWhitespace && this.$v?.form?.individualDetails?.[emailType].$anyError) {
            errors.push(invalidType(emailTypeSpace));
        }
        return errors;
    }
    async saveAccountHolderInfo(form) {
        const appUuid = this.appUUID;
        form.phoneNumber = form.phoneNumber.replace(/\s/g, '');
        form.individualDetails.phone_number = form.individualDetails.phone_number.replace(/\s/g, '');
        try {
            await this.$apollo.mutate({
                mutation: SaveAccountHolder,
                variables: {
                    input: {
                        appUuid,
                        businessDetails: form.businessDetails,
                        individualDetails: [form.individualDetails],
                        address: form.businessAddress,
                        websiteUrl: form.websiteUrl,
                        phoneNumber: form.phoneNumber.replace(/\s/g, ''),
                        email: form.email,
                    },
                },
            });
            this.successNotification('KYC information saved successfully');
            this.nextStep();
            this.isSaving = false;
        }
        catch (error) {
            this.errorNotification(error.message);
            this.isSaving = false;
        }
    }
    mapAccountHolderData(data) {
        const newBusinessDetails = _.pick(data.businessDetails, [
            'country_of_operation',
            'date_of_registration',
            'description',
            'industry_category',
            'legal_name',
            'trading_name',
            'type',
        ]);
        newBusinessDetails.date_of_registration = data.businessDetails?.date_of_registration;
        data.individualDetails[0].date_of_birth = data.individualDetails[0]?.date_of_birth;
        this.form = {
            businessDetails: newBusinessDetails,
            individualDetails: data.individualDetails[0],
            businessAddress: data.address,
            phoneNumber: data.phoneNumber,
            email: data.email,
            websiteUrl: data.websiteUrl,
        };
        this.accountHolderUuid = data.uuid;
        this.handleRegionChange(this.form.businessAddress.province_state);
        this.kycDocuments = data.kycDocuments;
    }
    async fetchDisbursementData() {
        try {
            const data = await this.$apollo.query({
                query: AppDisbursementQuery,
                variables: {
                    appUuid: this.appUUID,
                },
            });
            if ({ data }) {
                const { fetchAppByUuid } = data.data;
                const { disbursement } = fetchAppByUuid;
                if (!this.accountHolderUuid) {
                    this.form.businessDetails.legal_name = disbursement?.businessName || '';
                    this.form.phoneNumber = `+63${disbursement?.mobileNumber}`;
                    this.form.individualDetails.tax_identification_number = disbursement?.tin || '';
                    this.form.businessAddress.postal_code = disbursement?.postalCode || '';
                }
                this.birFileUrl = disbursement?.birUrl;
            }
        }
        catch (error) {
            this.errorNotification(error.message);
        }
    }
    mapAppOwnerData(data) {
        const { appOwnerEmail } = data;
        const { user } = data;
        this.form.individualDetails.given_names = user?.firstName;
        this.form.individualDetails.surname = user?.lastName;
        this.form.individualDetails.email = appOwnerEmail;
        this.form.individualDetails.date_of_birth = user?.birthdate;
        this.form.individualDetails.phone_number = user?.contactDialCode + user?.contactNumber;
        this.form.email = user?.businessEmailAddress;
    }
    refetchAccountHolder() {
        if (this.accountHolderUuid) {
            this.$apollo.queries.accountHolder.refetch();
        }
    }
    async onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.isSaving = true;
            try {
                await this.uploadBir();
                await this.saveAccountHolderInfo(this.form);
            }
            catch (error) {
                console.error(error);
            }
        }
    }
    onContinueLater() {
        this.showConfirmationDialog();
    }
    continueLater() {
        this.saveAccountHolderInfo(this.form);
        this.$router.go(-1);
        this.hideConfirmationDialog();
    }
    onCancelContinueLater() {
        this.$router.go(-1);
    }
    async uploadBir() {
        if (this.birFileUrl) {
            try {
                await this.$apollo.mutate({
                    mutation: FileAction,
                    variables: {
                        input: {
                            purpose: 'KYC_DOCUMENT',
                            accountHolderUuid: this.accountHolderUuid,
                            documentType: DocumentType.BIR_2303_DOCUMENT,
                            appUuid: this.appUUID,
                        },
                    },
                });
                this.refetchAccountHolder();
            }
            catch (error) {
                this.errorNotification(error.message);
                console.log(error);
            }
        }
    }
    async mounted() {
        await this.fetchRegions();
        await this.fetchDisbursementData();
    }
};
__decorate([
    Mutation('showConfirmationDialog')
], XenditKycVerification.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], XenditKycVerification.prototype, "hideConfirmationDialog", void 0);
XenditKycVerification = __decorate([
    Component({
        components: {
            PageTitle,
            BaseTextField,
            DatePicker,
            ActionButton,
            BaseTextArea,
            PhoneInput,
            KycDocumentForm,
            ConfirmationDialog,
            BaseOverlayLoader,
        },
        apollo: {
            accountHolder: {
                query: FetchAccountHolder,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                skip() {
                    return !this.appUUID;
                },
                update(data) {
                    if (data.fetchAccountHolder) {
                        const accounHolder = data.fetchAccountHolder;
                        this.mapAccountHolderData(accounHolder);
                        return data.fetchAccountHolder;
                    }
                    return null;
                },
                fetchPolicy: 'network-only',
            },
            appOwner: {
                query: AppOwnerDetails,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                skip() {
                    return !this.appUUID;
                },
                update(data) {
                    if (data.fetchAppByUuid && !this.accountHolderUuid) {
                        this.mapAppOwnerData(data.fetchAppByUuid);
                        return data.fetchAppOwner;
                    }
                    return null;
                },
                fetchPolicy: 'network-only',
            },
        },
        validations: {
            form: {
                businessDetails: {
                    legal_name: {
                        required,
                    },
                    type: {
                        required,
                    },
                    trading_name: {
                        required,
                    },
                    description: {
                        required,
                    },
                    industry_category: {
                        required,
                    },
                    date_of_registration: {
                        required,
                    },
                    country_of_operation: {
                        required,
                    },
                },
                individualDetails: {
                    role: {
                        required,
                    },
                    type: {
                        required,
                    },
                    given_names: {
                        required,
                    },
                    surname: {
                        required,
                    },
                    phone_number: {
                        required,
                        invalidMobile() {
                            const vm = this;
                            const { phone_number } = this.form.individualDetails;
                            return vm.isValidMobile(phone_number);
                        },
                    },
                    email: {
                        required,
                        email,
                    },
                    nationality: {
                        required,
                    },
                    date_of_birth: {
                        required,
                    },
                    gender: {
                        required,
                    },
                    tax_identification_number: {
                        required,
                    },
                },
                businessAddress: {
                    province_state: {
                        required,
                    },
                    city: {
                        required,
                    },
                    postal_code: {
                        required,
                    },
                    street_line1: {
                        required,
                    },
                    street_line2: {
                    //
                    },
                },
                phoneNumber: {
                    required,
                    invalidMobile() {
                        const vm = this;
                        const { phoneNumber } = this.form;
                        return vm.isValidMobile(phoneNumber);
                    },
                },
                email: {
                    required,
                    email,
                },
                websiteUrl: {
                    required,
                    url: (value) => /^https:\/\/([\w.-]+)\.([a-z]{2,6})(\/.*)*$/.test(value),
                },
            },
        },
        computed: {
            sortedProvinces() {
                return [...this.provinces].sort((a, b) => a.name.localeCompare(b.name));
            },
            sortedCities() {
                return [...this.cities].sort((a, b) => a.name.localeCompare(b.name));
            },
        },
    })
], XenditKycVerification);
export default XenditKycVerification;
